import { Pipe, PipeTransform } from '@angular/core';

import { UNDERSCORE } from '../utils/constant';

@Pipe({
	name: 'copoModelInfo',
})
export class ModelInfoPipe<T, K extends keyof T> implements PipeTransform {
	transform(value: T | undefined, infoField: K, replacement: string = UNDERSCORE) {
		if (value) {
			return value[infoField] && String(value[infoField]) !== ''
				? value[infoField]
				: replacement;
		}
		return replacement;
	}
}
